import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { pixelService } from 'services/PixelService';
import LegacyPixel from 'components/Pixel/LegacyPixel';
import { PIXEL_URL } from 'settings';
import { WithStyles } from 'shared/decorators/withStyles';

interface IState extends IStateBase {
  hasLegacy: boolean;
  addAffiliatePixel: string;
  frame: string;
}

@WithStyles(() => ({
  component: {
    position: 'absolute'
  }
}))
export default class Pixel extends BaseComponent<IState> {
  state = {
    hasLegacy: false,
    addAffiliatePixel: '',
    frame: ''
  };

  componentDidMount() {
    pixelService
      .init()
      .bindComponent(this)
      .filter(pixel => {
        /*
          hasLegacy: Should be removed in not too distance future
        */
        const scripts = Object.values(pixel.scripts).filter(value => value !== null);

        if (scripts.length === 0 && !pixel.frame) {
          this.setState({ hasLegacy: true });

          return false;
        }

        return true;
      })
      .subscribe(pixel => {
        const { scripts, frame } = pixel;

        if (scripts.analytics) {
          this.scriptPixel('ANALYTICS_PIXEL_SCRIPT', scripts.analytics);
        }

        if (scripts.tagmanager) {
          this.scriptPixel('TAGMANAGER_PIXEL_SCRIPT', scripts.tagmanager);
        }

        this.setState({ frame });
      });

    pixelService
      .setAffiliationCookie()
      .bindComponent(this)
      .subscribe(addAffiliatePixel => {
        this.setState({ addAffiliatePixel });
      });
  }

  scriptPixel = (id: string, script: any) => {
    if (script.head) {
      let newHeadElementScript;
      let headElementScript = document.getElementById(`${id}_HEAD`);

      if (!headElementScript) {
        newHeadElementScript = document.createElement('script');
        newHeadElementScript.setAttribute('id', `${id}_HEAD`);

        if (headElementScript !== newHeadElementScript) {
          headElementScript = newHeadElementScript;
        }
      }

      document.head.appendChild(headElementScript);
      headElementScript.innerHTML = script.head;
    }

    let bodyElementScript = document.createElement('script');

    bodyElementScript.innerHTML = script.body;

    document.body.appendChild(bodyElementScript);
  };

  render() {
    const { hasLegacy, addAffiliatePixel, frame } = this.state;

    return (
      <div className={this.props.classes.component}>
        {!hasLegacy ? (
          <React.Fragment>
            {addAffiliatePixel && (
              <iframe style={{ position: 'fixed' }} id="pixel-mark-affiliate" src={addAffiliatePixel} width="1" height="1" frameBorder="0" />
            )}
            {!!frame && (
              <iframe
                style={{ position: 'fixed' }}
                id="pixel-script"
                src={`${PIXEL_URL}/render/pixel/${frame}`}
                width="1"
                height="1"
                frameBorder="0"
              />
            )}
          </React.Fragment>
        ) : (
          <LegacyPixel />
        )}
      </div>
    );
  }
}
